import { Stack, type StackProps } from "@chakra-ui/react";
import * as React from "react";

export interface SectionBodyProps extends StackProps {
  children?: React.ReactNode;
}

export default function SectionBody(props: SectionBodyProps) {
  const { ...rootProps } = props;
  return (
    <Stack flex="1" {...rootProps}>
      {props.children}
    </Stack>
  );
}
